import React from 'react'
import Section from '../components/About.js/Section'
import Header from '../components/Homepage/Header'
import Navbar from '../components/Navbar'
import HomeSection from '../components/Homepage/HomeSection'
import Payment from '../components/Homepage/Payment'
import Service from '../components/Homepage/Service'
import Cta from '../components/Common/Cta'
import Usecase from '../components/Homepage/Usecase'
import Api from '../components/Homepage/Api'
import Faq from '../components/Common/Faq'
import Newsletter from '../components/Common/Newsletter'
import Footer from '../components/Common/Footer'

const Homepage = () => {
  return (
    <>
    <Navbar/>
    <Header/>
    <Section/>
    <HomeSection/>
    <Payment/>
    <Service/>
    <Cta/>
    <Usecase/>
    <Api/>
    <Faq/>
    <Newsletter/>
    <Footer/>

    </>
  )
}

export default Homepage